import React from 'react'
import { css } from 'styled-components'

// TODO: add size prop to re-use in flyout
export const TagIcon: React.FC<{
  icon: React.ReactElement
  backgroundColor: string
  borderWidth?: number
  testId?: string
}> = (props): React.ReactElement => {
  return (
    <span
      data-testid={props.testId}
      css={css`
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background-color: ${props.borderWidth === undefined
          ? props.backgroundColor
          : 'transparent'};
        border: ${props.borderWidth ?? 1}px dashed
          ${props.borderWidth ? props.backgroundColor : 'transparent'};
        width: 20px;
        height: 20px;
        padding: 1px;
        border-radius: 4px;
      `}
    >
      {props.icon}
    </span>
  )
}
